import Vue from 'vue'
import Toast from '../toast'

export default Vue.component(
  'toast-on-load',
  {
    props: [
      'heading',
      'message',
      'status'
    ],
    render () {
      return ''
    },
    mounted () {
      Vue.nextTick(() => {
        try {
          this.$toast[this.status]({
            component: Toast,
            props: {
              heading: this.heading,
              body: this.message
            }
          })
        } catch (err) {
          console.warn('Toast message status not valid - falling back to default type. Please use one of the following: info, success, warning or error.')
          this.$toast({
            component: Toast,
            props: {
              heading: this.heading,
              body: this.message
            }
          })
        }
      })
    }
  }
)
